<template lang="html">

  <section class="wrapper login row-center">

    <div class="cuadro-login">

      <template v-if="!view.loading">

        <div class="contenedor-login -student">

          <h2 class="titulo">Iniciar sesión</h2>

          <p>Inicia sesión con tu cuenta @students.esic.edu o @students.esic.university</p>

          <a href="https://oauth2.esic.edu/index.php?state=udp&mode=login" class="btn">Acceder</a>

        </div>
        <p>No recuerdo mis claves/No puedo acceder</p>
        <a class="link" href="https://campusvirtual.esic.edu/public/resend.php">Soy estudiante/Alumni de ESIC</a>
        <a class="link" href="https://cv.esic.university/public/">Soy estudiante de ESIC University Madrid</a>

      </template>


      <img src="@/assets/img/spinner-blue.svg" alt="cargando" width="120" v-else>
      

    </div>

    <img src="@/assets/img/logo-uni-white.svg" alt="Logo UDP" class="logo-udp">a

  </section>

</template>

<script lang="js">



  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  import { Validator } from "vee-validate";


  Vue.use(VeeValidate);

  import { mapActions, mapGetters } from 'vuex';

  import router from '@/router';



  export default {
    name: 'login',
    mounted() {
      if (!!this.$route.query.token) {
        this.view.loading = true;
        this.requestlogin({ token: this.$route.query.token }).then(r => {
          this.view.loading = false;

          router.push({ name: 'home' });
        }).catch(e => {
          this.view.loading = false
        });

      }
    },
    data() {
      return {
        logindata: {
          nick: '',
          password: ''
        },
        view: {
          loading: false,
          showolvidado: false
        }
      }
    },
    methods: {
      ...mapActions(['requestlogin']),
      login() {
        this.$validator.validateAll().then(canSend => {
          if (canSend) {
            this.view.loading = true;
            this.requestlogin(this.logindata).then(r => {
              this.view.loading = false;
              console.log(r);
              this.$router.push({ name: 'home' });
            }).catch(e => {
              this.view.loading = false
            });
          }
        });
      }
    },
    computed: {
      ...mapGetters({
        textos: 'getTexts'
      })
    },


  }
</script>

<style scoped lang="scss">
  p {
    width: 100%;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    margin-top: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/login.vue